import { HotelService } from './service';
import { extractTotalCount } from '../../components/common/tableStyles';

export const hotels = {
    state: {
        list: [],
        total: 0,
        isLoading: false,
        error: null,
    },
    reducers: {
        setHotels(state, payload) {
            const list = payload.data || payload;
            const total = extractTotalCount(payload, list);
            return { ...state, list: Array.isArray(list) ? list : [], total };
        },
        setLoading(state, payload) {
            return { ...state, isLoading: payload };
        },
        setError(state, payload) {
            return { ...state, error: payload };
        },
        removeHotel(state, id) {
            return {
                ...state,
                list: state.list.filter(h => h.id !== id && h._id !== id),
                total: Math.max(0, state.total - 1)
            };
        },
    },
    effects: (dispatch) => ({
        async fetchHotelsAsync(params = {}) {
            dispatch.hotels.setLoading(true);
            try {
                const data = await HotelService.getAll(params);
                dispatch.hotels.setHotels(data);
            } catch (error) {
                console.error("Failed to fetch hotels", error);
                dispatch.hotels.setError(error.message);
                throw error;
            } finally {
                dispatch.hotels.setLoading(false);
            }
        },
        async saveHotelAsync(hotelData) {
            try {
                dispatch.hotels.setLoading(true);
                await HotelService.save(hotelData);
                await dispatch.hotels.fetchHotelsAsync({ limit: 20, page: 0 });
            } catch (error) {
                console.error("Failed to save hotel", error);
                dispatch.hotels.setError(error.message);
                throw error;
            } finally {
                dispatch.hotels.setLoading(false);
            }
        },
        async changeHotelStatusAsync({ id, tenantId, status, reason }) {
            try {
                dispatch.hotels.setLoading(true);
                await HotelService.changeStatus(id, tenantId, status, reason);
                await dispatch.hotels.fetchHotelsAsync({ limit: 20, page: 0 });
            } catch (error) {
                console.error("Failed to change hotel status", error);
                dispatch.hotels.setError(error.message);
                throw error;
            } finally {
                dispatch.hotels.setLoading(false);
            }
        },
        async deleteHotelAsync(id) {
            try {
                dispatch.hotels.setLoading(true);
                dispatch.hotels.removeHotel(id);
                await HotelService.delete(id);
                await dispatch.hotels.fetchHotelsAsync({ limit: 20, page: 0 });
            } catch (error) {
                console.error("Failed to delete hotel", error);
                dispatch.hotels.setError(error.message);
                throw error;
            } finally {
                dispatch.hotels.setLoading(false);
            }
        },
        async archiveHotelAsync({ id, tenantId, reason, notes }) {
            try {
                dispatch.hotels.setLoading(true);
                await HotelService.archive(id, tenantId, reason, notes);
                await dispatch.hotels.fetchHotelsAsync({ limit: 20, page: 0 });
            } catch (error) {
                console.error("Failed to archive hotel", error);
                dispatch.hotels.setError(error.message);
                throw error;
            } finally {
                dispatch.hotels.setLoading(false);
            }
        },
        async restoreHotelAsync({ id, tenantId }) {
            try {
                dispatch.hotels.setLoading(true);
                await HotelService.restore(id, tenantId);
                await dispatch.hotels.fetchHotelsAsync({ limit: 20, page: 0 });
            } catch (error) {
                console.error("Failed to restore hotel", error);
                dispatch.hotels.setError(error.message);
                throw error;
            } finally {
                dispatch.hotels.setLoading(false);
            }
        }
    })
};
